export default {
    bindings: {
        'event': '<',
        'updateIsotope': '&'
    },
    controller: 'activityRowController',
    template: require('../views/activity.row.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/activity.row.component.js